import React from "react";

const ErrorModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Overlay */}
      <div
        className="fixed inset-0 bg-black bg-opacity-50"
        onClick={onClose}
        style={{ backdropFilter: "blur(2px)" }}
      />

      {/* Modal */}
      <div className="relative bg-white rounded-lg p-8 max-w-md w-full mx-4 z-10">
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>

        {/* Error message */}
        <div className="mt-2">
          <h3 className="text-lg font-medium text-gray-900 mb-2">Atenție</h3>
          <p className="text-gray-700 text-base">
            Pentru livrare în aceeași zi, comanda trebuie plasată cu cel puțin 3
            ore înainte de sfârșitul intervalului de livrare.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ErrorModal;
